import React, { useEffect, useState } from "react";
import Header from "./Header";
import "../assets/styles/ScandocumentScreenNew.css";
import scanDocPreImg from "../assets/images/scan-doc-pre-img.png";
import errorExclamation from "../assets/images/triangle-exclamation.svg";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const ScanDocumentScreenNew = ({
  docError,
  showDocSuccess,
  hasInitError,
  isDocScanEnabled,
  initStatus,
  initErrorStatus,
  docStatus,
  setDocError,
  setDocStatus,
}) => {
  const [showBtn, setShowBtn] = useState(true);
  const programId = sessionStorage.getItem("program_id");
  useEffect(() => {
    toggleBtn();
  }, [docStatus]);
  const toggleBtn = () => {
    if (!docStatus?.length) {
      setShowBtn(true);
    } else if (docStatus?.toLowerCase()?.includes("processing")) {
      setShowBtn(true);
    } else if (docStatus.toLowerCase().includes("error")) {
      setShowBtn(true);
    }
  };

  const handleDocBtn = () => {
    setShowBtn(false);
    setDocError("");
    setDocStatus("");
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Header />
      <div className="scan-document-container" style={{ flex: 1 }}>
        <h3>Take an Image of your document</h3>
        <div className="img-container">
          <img src={scanDocPreImg} />
        </div>
        <p style={{ fontSize: "16px" }}>
          Use your phone's camera to take an image of your document where your
          photo and personal details are shown
        </p>
        <div className="instructions">
          <h4>Make Sure</h4>

          <ul>
            <li>you are in a well-lit room</li>
            <li>the whole document is inside the frame</li>
            <li>there is no glare</li>
          </ul>
        </div>
        <p style={{ fontSize: "1rem" }}>
          Select <b>Continue</b> and then follow instructions
        </p>
      </div>
      <p
        id="docStatus"
        style={{
          display: "none",
        }}
      ></p>
      {docStatus && !showDocSuccess && !docError && (
        <div className="selfie-custom-status" role="status" aria-live="polite">
          <p className="status-text">{docStatus}</p>
        </div>
      )}
      {showDocSuccess && (
        <div className="success-message" role="status" aria-live="polite">
          <p className="success-text">
            ✓ Scan Document successful. You may now proceed with Selfie Image.
          </p>
        </div>
      )}
      {docError && (
        <div className="error-message" role="alert" aria-live="polite">
          <p className="error-text">{docError}</p>
          <p className="error-instruction">
            <img src={errorExclamation} style={{ alignSelf: "baseline" }} />
            Please rescan the document to continue.
          </p>
        </div>
      )}

      {hasInitError && initErrorStatus && (
        <div className="error-message" role="alert" aria-live="polite">
          <p className="error-text">
            <img src={errorExclamation} style={{ alignSelf: "baseline" }} />
            {initErrorStatus}
          </p>
        </div>
      )}
      <div
        style={{ display: showBtn ? "flex" : "none" }}
        className="scan-doc-button-container"
      >
        <button
          id="docScanButton"
          className={`continue-button ${
            programId == TOEFL_PROGRAM_ID ? "toefl-button-bg" : "gre-button-bg"
          }`}
          style={{ marginBottom: "1rem" }}
          aria-label="Scan Document - Step 2"
          type="button"
          onClick={() => {
            handleDocBtn();
          }}
          disabled={
            !isDocScanEnabled || (docStatus && !showDocSuccess && !docError)
          }
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ScanDocumentScreenNew;
